// extracted by mini-css-extract-plugin
export default {"attachmentItem":"MultipleAttachmentsSlider__attachmentItem___SuTVt","scrollableCarouselWrapper":"MultipleAttachmentsSlider__scrollableCarouselWrapper___Kcb_6"};